export default {
  title: 'Ship Agent Management',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Agent name, EDI code',
    port: 'Port',
    portPlaceholder: 'Select port',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addShipAgent: 'Add Ship Agent',
    selectFromLibrary: 'Select from Library',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    edit: 'Edit',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    agentName: 'Agent Name',
    ediCode: 'EDI Code',
    port: 'Port',
    abbreviation: 'Abbreviation',
    status: 'Status',
    operation: 'Operation'
  },

  // Form
  form: {
    addTitle: 'Add Ship Agent',
    editTitle: 'Edit Ship Agent',
    agentCode: 'Agent Code',
    agentCodePlaceholder: 'Please enter agent code',
    agentNameCn: 'Agent Name (Chinese)',
    agentNameCnPlaceholder: 'Please enter Chinese name',
    agentNameEn: 'Agent Name (English)',
    agentNameEnPlaceholder: 'Please enter English name',
    country: 'Country',
    countryPlaceholder: 'Select country',
    city: 'City',
    cityPlaceholder: 'Please enter city',
    contactPerson: 'Contact Person',
    contactPersonPlaceholder: 'Please enter contact person',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone number',
    email: 'Email',
    emailPlaceholder: 'Please enter email address',
    status: 'Status',
    statusPlaceholder: 'Select status'
  },

  // Selection modal
  modal: {
    title: 'Add Ship Agent',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} ship agents, {total} available'
  },

  // Confirmation dialogs
  confirm: {
    enableItem: 'Are you sure to enable this ship agent?',
    disableItem: 'Are you sure to disable this ship agent?',
    batchEnable: 'Are you sure to enable the selected {count} ship agents?',
    batchDisable: 'Are you sure to disable the selected {count} ship agents?'
  },

  // Form validation
  validation: {
    agentCodeRequired: 'Please enter agent code',
    agentNameCnRequired: 'Please enter Chinese name',
    agentNameEnRequired: 'Please enter English name',
    countryRequired: 'Please select country',
    contactPersonRequired: 'Please enter contact person',
    phoneRequired: 'Please enter phone number',
    emailRequired: 'Please enter email address',
    emailFormat: 'Please enter valid email format',
    selectItems: 'Please select ship agents to associate'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select ship agents to enable',
    selectToDisable: 'Please select ship agents to disable',
    selectToAssociate: 'Please select ship agents to associate',
    loadError: 'Failed to load ship agent data, please try again later',
    platformLoadError: 'Failed to load platform ship agent data, please try again later',
    saveSuccess: 'Ship agent saved successfully',
    saveError: 'Failed to save, please try again later',
    updateSuccess: 'Ship agent updated successfully',
    updateError: 'Failed to update, please try again later',
    associateSuccess: 'Successfully associated {count} ship agents',
    associateError: 'Failed to associate, please try again later',
    statusToggleSuccess: 'Ship agent has been {status}',
    statusToggleError: 'Failed to toggle status, please try again later',
    batchEnableSuccess: 'Enabled {count} ship agents',
    batchEnableError: 'Failed to batch enable, please try again later',
    batchDisableSuccess: 'Disabled {count} ship agents',
    batchDisableError: 'Failed to batch disable, please try again later'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  }
}